import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String
  }

  visit() {
    if (this.hasIdValue) {
      Turbo.visit(`/users/${this.idValue}`)
    }
  }
}
